import styled from 'styled-components'

export const StyledSpecsAdvanceFilters = styled.div`
  .pointer {
    cursor: 'pointer';
  }
`
